<template>
    <div >
        <b-modal id="reset_writing" ref="reset_writing" hide-footer centered>
            <b-row class="header-test d-flex align-items-center mb-3 ">
                <b-col sm="6" class="left_header">
                    <div class="box_title">Chỉnh sửa bài viết</div>
                </b-col>
                <b-col sm="6" class="d-flex justify-content-end right_header">
                    <div class="box_time d-flex align-items-center time-box-sticky" >
                        <div class="icon_clock">
                            <img src="~@/assets/clock.png" alt="">
                        </div>
                        <div class="time-end">{{ modalData.time_remaining | secondToMinute }}</div>
                    </div>
                </b-col>
            </b-row>
            <div>
                <div v-html="modalData.description"></div>
                <p><strong>Bài viết của bạn:</strong></p>
                <quill-editor style="height: 300px" v-model="modalData.writing" :options="editorOption" @input="updateWriting">
                    <div id="toolbar" slot="toolbar">
                        <!-- Add a bold button -->
                        <button class="ql-bold">Bold</button>
                        <button class="ql-italic">Italic</button>
                        <select class="ql-header">
                            <option value="1">Heading 1</option>
                            <option value="2">Heading 2</option>
                            <option value="3">Heading 3</option>
                            <option value="4">Heading 4</option>
                            <option value="5">Heading 5</option>
                            <option value="6">Heading 6</option>
                            <option value="">Normal</option>
                        </select>
                    </div>
                </quill-editor>
            </div>
            <div class="d-flex justify-content-center" style="margin-top: 5rem !important;">
                <b-button variant="primary" @click="saveWriting" style="padding: 6px 30px;
    font-size: 17px;">Lưu</b-button>
            </div>
        </b-modal>
        <b-modal id="check_character" ref="check_character"  hide-footer centered>
             <div class="text-center">
                Bài làm của bạn phải ít nhất 50 ký tự thì mới có thể nộp bài .
             </div>
        </b-modal>
        <b-container class="box_test">
            <div class="dotted">
            </div>
            <b-row class="d-lex  mt-5">
                <b-col lg="12" >
                     <div>
                        <h1 style="text-align: center;">Bài làm của bạn</h1>
                        <ul>
                        <li v-for="(part, index) in filteredParts" :key="index">
                            <hr>
                            <div style="font-size:25px;font-weight: bold;">
                                {{ part.name }} 
                            </div>
                            <div v-if="part.questions " style="font-size:20px">
                                <div v-for="(question, qIndex) in part.questions" :key="qIndex" >
                                    <div v-if="question.content_type == 1">
                                        <span v-html="question.content" class="question_content"></span>
                                        <!-- <span>Câu : {{ qIndex + 1 }}</span> -->
                                        <div v-if="!question.option_data.some(option => option.id == question.answers[0])">
                                            <p style="font-weight: bold;">Bạn chưa trả lời câu hỏi</p>
                                        </div>
                                        <div v-else>
                                            <div v-for="(option, oIndex) in question.option_data" :key="oIndex">
                                                <div v-if="option.id == question.answers[0]">
                                                    <p v-html="option.content" ></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if ="question.content_type == 3">
                                        <div v-html="replacePlaceholders(question.content, question.answers)" class="question_content_type3"></div>
                                    </div>
                                    <div v-else-if="question.content_type == 6">
                                        <span>{{ getTitle(question.content) }}</span>
                                        <div v-if="!question.answers || !question.answers.value">
                                             <p class="question_none" style="font-weight: bold;">Bạn chưa trả lời câu hỏi</p>
                                        </div>
                                        <div v-else>
                                            <audio controls>
                                                <source :src="question.answers.value" type="audio/mpeg">
                                                Trình duyệt của bạn không hỗ trợ thẻ audio.
                                            </audio>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                          <div class="writing">
                            <div v-if="part.part_type == 1">
                                <div v-if="part.writing === null || part.writing === undefined || part.writing.trim() === ''">
                                    <p v-if="localWritingData[part.id]" >
                                        {{ localWritingData[part.id] }}
                                    </p>
                                    <p v-else style="font-weight: bold; font-size: 20px;">Bạn chưa trả lời câu hỏi</p>
                                </div>
                                <div v-else>
                                    <span v-html="part.writing" ></span>
                                </div>
                                <div v-if="part.time_remaining > 0">
                                    <b-button class="btn-edit" @click="editWriting(part);">Edit</b-button>
                                </div>
                                <div v-if="part.time_remaining <= 0">
                                    <div class="text-center fs-6">
                                        Thời gian làm bài đã hết, nếu bài làm ghi nhận không đúng với bạn đã làm
                                        <p class="fw-bold">"Bạn vui lòng liên hệ Tư vấn viên để được hỗ trợ"</p>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center " >
                <b-button @click="handleButtonClick();" class="btn-custom" variant="success">Nộp bài</b-button>
            </div>
           
        </b-container>
    </div>
</template>
<script>
import page3Mixin from '@/plugins/TestPlugin/mixins/page3'

    export default {
         mixins: [page3Mixin],
        computed: {
            filteredParts() {
                return this.examParts.map(part => {
                    return {
                        ...part,
                        questions: part.questions?.filter(question => question.content_type != 5) || []
                    };
                });
            },
        },
        data() {
            return {
            localWritingData: {},
            examParts: [],
            modalData: {
                id: null,
                description: "",
                writing: "",
                time_remaining: null
               },
            countdownInterval: null, // Biến lưu setInterval
            editorOption: {
            modules: {
                toolbar: '#toolbar'
            },
            },
            };
        },
        mounted() {
            if (!this.$TestApp || typeof this.$TestApp._getExam !== 'function') {
            return;
            
            }
            this.examParts = this.$TestApp._getExam().part;
            this.$root.$on('bv::modal::hide', (modalId) => {
                if (modalId === 'reset_writing') {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
            });
            this.examParts.forEach((part) => {
                if (part.part_type === 1 && (!part.writing || part.writing.trim() === '')) {
                    var storedData = localStorage.getItem(part.id);
                    if (storedData) {
                        storedData = storedData.replace(/^<p>|<\/p>$/g, '');
                        this.$set(this.localWritingData, part.id, storedData);
                        this.saveStoredData(part.id, storedData);
                    }

                }
             });

        },
        methods: {
            handleButtonClick() {
                this.$TestApp.testSubmit();  
                this.$TestApp.goToPage(8);   
            },
            replacePlaceholders(content, answers) {
                let result = content;
                if (!answers || answers.length === 0) {
                    result = result.replaceAll('$$',`<input type="text" value="" readonly style="border: 1px solid #ccc; border-radius: 10px;">`
                    );
                } else {
                    answers.forEach((answer) => {
                        if (answer) {
                            const styledAnswer = `<input type="text" value="${answer}" readonly style="border: 1px solid #ccc; border-radius: 10px;text-align: center;">`;
                            result = result.replace('$$', styledAnswer);
                        } else {
                            // const styledAnswer = `<span style="font-style: italic; font-weight: bold;margin-right: 10px;font-size: 17px;color: red;">bạn chưa trả lời</span>`;
                            const styledAnswer = `<input type="text" value="" readonly style="border: 1px solid #ccc; border-radius: 10px;">`;
                            result = result.replace('$$', styledAnswer);
                        }
                    });
                }
                return result
            },
            getTitle(content) {
                const data = JSON.parse(content);
                return data.title; 
            },
            editWriting(part){
                this.modalData = { 
                    id: part.id,
                    description: part.description,
                    writing: part.writing,
                    time_remaining:part.time_remaining
                };
                this.$nextTick(() => {
                    this.$bvModal.show('reset_writing');
                    this.startCountdown();
                });
            },
            saveWriting() {

                const partIndex = this.examParts.findIndex(part => part.id === this.modalData.id);
                const textContent = this.modalData.writing.replace(/<[^>]*>/g, '').trim();
                if (this.modalData.time_remaining > 0) {
                    if (textContent.length <= 50) {
                        this.$bvModal.show('check_character')
                    } else {
                        if (partIndex !== -1) {
                            this.$set(this.examParts, partIndex, { 
                                ...this.examParts[partIndex], 
                                writing: this.modalData.writing,
                                time_remaining:this.modalData.time_remaining
                            });
                        }
                        this.$nextTick(() => {
                            this.$bvModal.hide('reset_writing');
                        });
                    }
                }else{
                    this.$set(this.examParts, partIndex, { 
                        ...this.examParts[partIndex], 
                        writing: this.modalData.writing,
                        time_remaining:this.modalData.time_remaining
                    });
                    this.$nextTick(() => {
                       this.$bvModal.hide('reset_writing');
                    });
                }
            },
            updateWriting(value) {
                this.modalData.writing = value;
            },
            startCountdown() {
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                }
                if (!this.modalData.time_remaining || this.modalData.time_remaining <= 0) return;

                this.countdownInterval = setInterval(() => {
                    if (this.modalData.time_remaining > 0) {
                        this.modalData.time_remaining--;
                    } else {
                        clearInterval(this.countdownInterval);
                        this.countdownInterval = null;
                        this.saveWriting();
                    }
                }, 1000);
            },
            saveStoredData(partId, storedData) {
                if (storedData) {
                    const partIndex = this.examParts.findIndex(part => part.id === partId);
                    if (partIndex !== -1) {
                            this.$set(this.examParts, partIndex, { 
                                ...this.examParts[partIndex], 
                                writing: storedData,
                            });
                        }
                }
            }
        }
    }
</script>
<style >
    ul li{
      text-decoration: none;
      list-style: none;
    }
    .distance{
        padding-bottom: 90px;
    }
    .box_test{
        /* height: 70vh; */
        background: #fff;
        border-radius: 20px;
        background: url(~@/assets/bg-box-test.png);
        background-repeat: repeat;
        /* overflow-y: scroll; */
        position: relative;
        padding-bottom: 120px !important;
        padding: 50px 40px;
        box-shadow: 0px 8px 0px #1990ef;
        margin-top: 20px;
    }
    .dotted{
        position: absolute;
        width: 95%;
        top: -2px;
        background: url(~@/assets/dotted-box-test.png);
        background-repeat: repeat-x;
        height: 55px;
        left: 49.5%;
        transform: translateX(-50%);
    }
    .mt-5{
        margin-top: 0 !important;
    }
    hr {
    width: 70%;
    margin: 10px auto 20px;
    height: 3px;
    background: black;
    }
    .btn-edit{
        background-color: #73e546;
    color: #fff;
    font-weight: 900;
    border-radius: 25px;
    padding: 5px 25px;
    display: inline-block;
    border: 1px solid #46a520;
    box-shadow: 0px 4px 2px #46a520, 0px 0px 11px 3px #ffffff5c inset;
    margin: 0 auto;
    }
    .modal-dialog {
        max-width: 65% !important;
    }
    .time-box-sticky{
    padding: 5px 10px;
    justify-content: space-between;
    background-color: #fee138;
    width: 28%;
    box-shadow: 0px 0px 20px 20px #0000001a;
    transition: all .2s;
    border: 1px solid #025dad;
    border-radius: 20px;
    }
    .icon_clock{
        width: 30px;
    height: 30px;
    margin-right: 10px;
    display: flex;
    }
    .time-end{
        font-size: 15px;
    color: #025dad;
    font-weight: 700;
    }
    .box_title{
        background: #fee138;
    border: 1px solid #025dad;
    border-radius: 15px;
    padding: 5px 15px;
    width: fit-content;
    font-size: 15px;
    color: #025dad;
    font-weight: 700;
    }
    @media only screen and (max-width: 768px){
        .dotted {
            width: 80%;
            background-size: 28%;

        }
    }
</style>